// extracted by mini-css-extract-plugin
export default {"forbidden":"Forbidden_forbidden__jkziW","lock":"Forbidden_lock__wao6n","dip":"Forbidden_dip__FtzPJ","spin":"Forbidden_spin__4rsln"};